import React, { useState, useEffect } from 'react';

const PartnersTab = () => {
    const [partners, setPartners] = useState([]);
    const [uploading, setUploading] = useState(false);

    useEffect(() => {
        fetchPartners();
    }, []);

    const fetchPartners = async () => {
        const res = await fetch('/api/partners');
        const data = await res.json();
        setPartners(data);
    };

    const handleUpload = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        setUploading(true);
        const formData = new FormData();
        formData.append('logo', file);

        const res = await fetch('/api/partners', {
            method: 'POST',
            body: formData
        });

        if (res.ok) {
            fetchPartners();
            e.target.value = null; // Reset input
        }
        setUploading(false);
    };

    const handleDelete = async (id) => {
        if(!window.confirm("Delete this partner logo?")) return;
        await fetch(`/api/partners/${id}`, { method: 'DELETE' });
        fetchPartners();
    };

    return (
        <div className="bg-white p-6 rounded-2xl shadow-sm border border-slate-100">
            <div className="flex justify-between items-center mb-6">
                <div>
                    <h3 className="text-lg font-black text-slate-800 uppercase">Trusted Partners</h3>
                    <p className="text-xs text-slate-400">Logos shown in "Trusted By" section</p>
                </div>
                <label className="bg-slate-900 text-white px-4 py-2 rounded-lg font-bold uppercase text-xs cursor-pointer hover:bg-orange-500 transition-colors">
                    {uploading ? 'Uploading...' : '+ Add Logo'}
                    <input type="file" className="hidden" accept="image/*" onChange={handleUpload} disabled={uploading} />
                </label>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-6">
                {partners.map((p) => (
                    <div key={p.id} className="group relative bg-slate-50 border border-slate-100 rounded-xl p-4 flex items-center justify-center aspect-square">
                        <img src={`${p.logo_path}`} alt="Partner" className="max-h-12 w-auto object-contain" />
                        <button 
                            onClick={() => handleDelete(p.id)}
                            className="absolute -top-2 -right-2 bg-red-500 text-white w-6 h-6 rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity shadow-md"
                        >
                            ×
                        </button>
                    </div>
                ))}
                {partners.length === 0 && <p className="col-span-full text-center text-slate-400 py-8">No partners added yet.</p>}
            </div>
        </div>
    );
};

export default PartnersTab;